export const PURCHASE_RESET = 'redux-app/purchases/PURCHASE_RESET';
export const GET_PURCHASE_PENDING = 'redux-app/purchases/GET_PURCHASE_PENDING';
export const GET_PURCHASE_SUCCESS = 'redux-app/purchases/GET_PURCHASE_SUCCESS';
export const GET_PURCHASE_FAIL = 'redux-app/purchases/GEt_PURCHASE_FAIL';
export const CREATE_PURCHASE_PENDING = 'redux-app/purchases/CREATE_PURCHASE_PENDING';
export const CREATE_PURCHASE_SUCCESS = 'redux-app/purchases/CREATE_PURCHASE_SUCCESS';
export const CREATE_PURCHASE_FAIL = 'redux-app/purchases/CREATE_PURCHASE_FAIL';
